<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="clearfix flex justify-between">
        <span>账户</span>
      </div>
      <div class="">
        <el-table
          :data="shopAccountManageInfo.shopAccounts"
          style="width: 100%"
          border
          stripe
        >
          <el-table-column prop="acctId" label="账户编号" align="center" />
          <el-table-column prop="acctName" label="账户名称" align="center" />
          <el-table-column prop="acctTypeName" label="账户类型" align="center" />
          <el-table-column prop="amount" label="账户金额" align="center" />
          <el-table-column prop="createTime" label="创建时间" align="center" />
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.acctType === '2003' && scope.row.amount > 0"
                size="mini"
                @click="_openAddAccountWithdrawalApplyModal(scope.row)"
              >
                提现
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="shopAccountManageInfo.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <add-account-withdrawal-apply ref="addAccountWithdrawalApply" />
  </div>
</template>

<script>
import { queryAccount } from '@/api/goods/accountApi'
import { getShopId } from '@/api/shop/shopApi'
import AddAccountWithdrawalApply from '@/components/goods/addAccountWithdrawalApply/addAccountWithdrawalApply'

export default {
  name: 'ShopAccountManage',
  components: {
    AddAccountWithdrawalApply
  },
  data() {
    return {
      shopAccountManageInfo: {
        shopAccounts: [],
        total: 0,
        conditions: {
          shopId: ''
        }
      },
      pagination: {
        currentPage: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this._listshopAccounts()
  },
  methods: {
    async _listshopAccounts() {
      try {
        const params = {
          ...this.shopAccountManageInfo.conditions,
          shopId:  getShopId(),
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        }
        const res = await queryAccount(params)
        this.shopAccountManageInfo.shopAccounts = res.data
        this.shopAccountManageInfo.total = res.total
      } catch (error) {
        console.error('获取账户列表失败:', error)
      }
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this._listshopAccounts()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this._listshopAccounts()
    },
    _openAddAccountWithdrawalApplyModal(shopAccount) {
      this.$refs.addAccountWithdrawalApply.open(shopAccount)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
.ibox-content {
  padding: 20px;
}
</style>